import { render, staticRenderFns } from "./StageConsignmentStartedDeliveryAddress.vue?vue&type=template&id=07572534&scoped=true&"
import script from "./StageConsignmentStartedDeliveryAddress.vue?vue&type=script&lang=ts&"
export * from "./StageConsignmentStartedDeliveryAddress.vue?vue&type=script&lang=ts&"
import style0 from "./StageConsignmentStartedDeliveryAddress.vue?vue&type=style&index=0&id=07572534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07572534",
  null
  
)

export default component.exports